var _sodipodiNamedview, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCarabiner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60.789082mm",
    height: "80.402061mm",
    viewBox: "0 0 60.789082 80.402061",
    id: "svg1",
    xmlSpace: "preserve",
    sodipodiDocname: "bota.svg",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview1",
    pagecolor: "#ffffff",
    bordercolor: "#000000",
    borderopacity: 0.25,
    inkscapeShowpageshadow: 2,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    inkscapeDeskcolor: "#d1d1d1",
    "inkscapeDocument-units": "mm",
    inkscapeZoom: 1.4485269,
    inkscapeCx: 368.99555,
    inkscapeCy: 354.15289,
    "inkscapeWindow-width": 1484,
    "inkscapeWindow-height": 1032,
    "inkscapeWindow-x": 367,
    "inkscapeWindow-y": 12,
    "inkscapeWindow-maximized": 0,
    "inkscapeCurrent-layer": "svg1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1",
    transform: "matrix(0.26458333,0,0,0.26458333,-24.384532,-37.647361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 229.29778,142.66813 c -0.825,0.162 -4.875,0.831 -9,1.488 -11.169,1.777 -32.917,9.334 -46.5,16.157 -42.66,21.428 -71.805,51.502 -80.059001,82.611 -2.326,8.763 -2.028,26.333 0.56,33.051 3.566,9.259 7.828001,16.887 10.712001,19.172 2.359,1.869 3.656,2.13 8.446,1.704 4.443,-0.395 7.951,-1.753 16.336,-6.324 11.327,-6.174 13.493,-8.51 13.519,-14.585 0.017,-3.789 -3.985,-16.8 -5.168,-16.8 -1.639,0 -17.263,6.043 -19.625,7.591 -1.357,0.889 -2.153,1.108 -1.768,0.486 0.975,-1.578 18.35,-14.924 21.652,-16.631 1.492,-0.772 4.788,-4.525 7.325,-8.34 11.769,-17.703 39.828,-37.456 66.57,-46.863 17.639,-6.205 33.1,-6.875 43.314,-1.878 6.42,3.141 12.987,9.886 16.025,16.459 2.157,4.668 2.161,4.812 2.161,84.176 v 79.5 l -2.457,5 c -3.14,6.39 -10.153,13.403 -16.543,16.543 -4.535,2.228 -6.163,2.45 -17.5,2.383 -10.979,-0.065 -13.352,-0.396 -19.5,-2.72 -3.85,-1.455 -7.121,-2.298 -7.268,-1.872 -1.348,3.894 -9.691,15.219 -12.815,17.396 -8.139,5.673 -22.75,7.165 -32.064,3.273 -2.013,-0.841 -3.928,-1.261 -4.255,-0.934 -1.566,1.566 18.786,16.799 29.902,22.382 23.666,11.886 53.594,14.445 76.271,6.522 26.088,-9.115 45.68,-30.941 52.935,-58.973 1.883,-7.276 1.883,-169.724 0,-177 -4.015,-15.515 -11.767,-29.185 -22.606,-39.865 -16.105,-15.869 -35.45,-23.688 -58.1,-23.484 -4.95,0.045 -9.675,0.213 -10.5,0.375 m -47.251,106.022 c -19.72,5.412 -22.223,9.736 -17.41,30.08 8.359,35.329 4.881,64.156 -10.879,90.173 -2.959,4.885 -5.833,10.9 -6.386,13.367 -3.706,16.538 10.894,31.861 27.392,28.748 7.505,-1.415 11.961,-4.968 18.159,-14.477 23.902,-36.668 30.637,-85.804 17.823,-130.023 -5.981,-20.638 -9.843,-23.042 -28.699,-17.868 m -18.396,129.378 c -6.661,4.062 -6.689,15.069 -0.049,19.118 11.326,6.906 23.325,-5.523 16.051,-16.625 -2.996,-4.573 -10.638,-5.763 -16.002,-2.493",
    stroke: "none",
    fill: "#fbfbfb",
    fillRule: "evenodd",
    id: "path1",
    style: {
      fill: "#a79fec",
      fillOpacity: 1
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarabiner);
export default __webpack_public_path__ + "static/media/carabiner.15dfbed899ff43935df524cd8e28dde1.svg";
export { ForwardRef as ReactComponent };